import { gql, TypedDocumentNode } from "@apollo/client";

import { BlueprintVersionedGroup, QueryBlueprintVersionedGroupArgs } from "types/generated";

type GetTemplateData = {
  blueprintVersionedGroup: BlueprintVersionedGroup;
};

export const GET_TEMPLATE: TypedDocumentNode<GetTemplateData, QueryBlueprintVersionedGroupArgs> =
  gql`
    query GetTemplate($id: ID!) {
      blueprintVersionedGroup(id: $id) {
        id
        canDelete
        description
        labels
        name
        createdAt
        updatedAt
        latestVersion {
          id
          version
        }
        space {
          accessLevel
          id
          name
        }
        ulid
      }
    }
  `;
